/**
 * 这个文件作为组件的目录
 * 目的是统一管理对外输出的组件，方便分类
 */
/**
 * 布局组件
 */

/**
 * 权限控制组件
 */
import ActionButton from './common/ActionButton';
import PageActionGate from './common/PageActionGate';
import PermissionGate from './common/PermissionGate';
import ProtectedRoute from './common/ProtectedRoute';
import ReportPermissionGate from './common/ReportPermissionGate';
import Footer from './Footer';
import { Question, SelectLang } from './RightContent';
import { AvatarDropdown, AvatarName } from './RightContent/AvatarDropdown';

export {
  AvatarDropdown,
  AvatarName,
  Footer,
  Question,
  SelectLang,
  // Permission components
  ActionButton,
  PageActionGate,
  PermissionGate,
  ProtectedRoute,
  ReportPermissionGate,
};
